<template>
  <div>
    <!-- ── JetonPay ── -->
    <form class="dep-form-frame" :class="{ 'colu-12 ga-4': !isMobile }">
      <div class="colu colu-12">
        <label class="colu-12 for-label">{{ $t('Bao.jeton_account') }}</label>
        <input
          :value="jcash.voucherNumber"
          :class="isMobile ? 'for-input inpType' : 'for-input'"
          type="text"
          :placeholder="$t('Bao.jeton_account')"
          @input="
            $emit('update:jcash', { voucherNumber: $event.target.value });
            $emit('check-jeton-errors')
          "
        >
        <div v-for="error in jetonErrors" :key="error" class="input-feedback text-align-R">
          {{ error }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'DepositUseJetonPay',
  inject: ['$validator'],
  props: {
    /** 渠道 typeCode，決定顯示哪組欄位 */
    typeCode: {
      type: String,
      default: ''
    },
    /** JetonCash 欄位資料 */
    jcash: {
      type: Object,
      default: () => ({ voucherNumber: '', expirationDate: '', securityCode: '', currency: 'EUR' })
    },
    /** 錯誤陣列 */
    jetonErrors: { type: Array, default: () => [] },
    /** Mobile 版 */
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  }
}
</script>
